// extracted by mini-css-extract-plugin
export default {"event":"timeline_event__MRts5","eventContent":"timeline_eventContent__rK1b3","name":"timeline_name__VbqZY","description":"timeline_description__xknOC","icon":"timeline_icon__EuhDG"};